import { render, staticRenderFns } from "./Quickpay.vue?vue&type=template&id=82df38fa&scoped=true"
import script from "./Quickpay.vue?vue&type=script&lang=js"
export * from "./Quickpay.vue?vue&type=script&lang=js"
import style0 from "./Quickpay.vue?vue&type=style&index=0&id=82df38fa&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82df38fa",
  null
  
)

export default component.exports